const AREA_SENDAI = "仙台市";
const AREA_SENDAI_OUTSIDE = "仙台市外";
const AREA_IWATE = "岩手県";
const AREA_AKITA = "秋田県";
const AREA_YAMAGATA = "山形県";
const AREA_FUKUSHIMA = "福島県";

const GENRE_ITALIAN = "イタリアン";
const GENRE_ITALIAN_CAFE = "イタリアン/カフェ";
const GENRE_CAFE = "カフェ";
const GENRE_PATISSERIE = "パティスリー・ケーキ屋";
const GENRE_HOTEL = "ホテル・旅館";
const GENRE_CHINESE = "中華";
const GENRE_SUSHI = "寿司";
const GENRE_IZAKAYA = "居酒屋";
const GENRE_WESTERN = "洋食";

const POSITION_SUPERVISOR = "スーパーバイザー";
const POSITION_OTHER = "その他";
const POSITION_KITCHEN_STAFF = "キッチンスタッフ";
const POSITION_RESTAURANT_SERVICE_STAFF = "レストランサービス・ホールスタッフ";
const POSITION_MANAGER_CANDIDATE = "店長・店長候補";
const POSITION_PATISSIER = "パティシエ";
const POSITION_HEAD_CHEF_CANDIDATE = "料理長・料理長候補";

const FILTER_POSITION_SERVICE_STAFF = "サービススタッフ";
const FILTER_POSITION_HEAD_CHEF = "料理長";
const FILTER_POSITION_MANAGER = "店長";

export const sendaiConfig = {
    jobs: [],
    filters: {
        area: [AREA_SENDAI, AREA_SENDAI_OUTSIDE, AREA_IWATE, AREA_AKITA, AREA_YAMAGATA, AREA_FUKUSHIMA],
        genre: [
            GENRE_ITALIAN_CAFE,
            GENRE_CHINESE,
            GENRE_IZAKAYA,
            GENRE_WESTERN,
            GENRE_SUSHI,
            GENRE_HOTEL
        ],
        position: [
            POSITION_KITCHEN_STAFF,
            FILTER_POSITION_SERVICE_STAFF,
            FILTER_POSITION_HEAD_CHEF,
            FILTER_POSITION_MANAGER,
            POSITION_OTHER
        ]
    },

    filtersList: {
        area: [
            { areaName: AREA_SENDAI, dataClickLabel: 'CT_Jobinformation_エリア-仙台' },
            { areaName: AREA_SENDAI_OUTSIDE, dataClickLabel: 'CT_Jobinformation_エリア-仙台市外' },
            { areaName: AREA_IWATE, dataClickLabel: 'CT_Jobinformation_エリア-岩手' },
            { areaName: AREA_AKITA, dataClickLabel: 'CT_Jobinformation_エリア-秋田' },
            { areaName: AREA_YAMAGATA, dataClickLabel: 'CT_Jobinformation_エリア-山形' },
            { areaName: AREA_FUKUSHIMA, dataClickLabel: 'CT_Jobinformation_エリア-福島' }
        ],
        genre: [
            { genreName: GENRE_ITALIAN_CAFE, dataClickLabel: 'CT_Jobinformation_料理ジャンル-イタリアン/カフェ' },
            { genreName: GENRE_CHINESE, dataClickLabel: 'CT_Jobinformation_料理ジャンル-中華' },
            { genreName: GENRE_IZAKAYA, dataClickLabel: 'CT_Jobinformation_料理ジャンル-居酒屋' },
            { genreName: GENRE_WESTERN, dataClickLabel: 'CT_Jobinformation_料理ジャンル-洋食' },
            { genreName: GENRE_SUSHI, dataClickLabel: 'CT_Jobinformation_料理ジャンル-寿司' },
            { genreName: GENRE_HOTEL, dataClickLabel: 'CT_Jobinformation_料理ジャンル-ホテル・旅館' }
        ],
        position: [
            { positionName: POSITION_KITCHEN_STAFF, dataClickLabel: 'CT_Jobinformation_職種-キッチンスタッフ' },
            { positionName: FILTER_POSITION_SERVICE_STAFF, dataClickLabel: 'CT_Jobinformation_職種-サービススタッフ' },
            { positionName: FILTER_POSITION_HEAD_CHEF, dataClickLabel: 'CT_Jobinformation_職種-料理長' },
            { positionName: FILTER_POSITION_MANAGER, dataClickLabel: 'CT_Jobinformation_職種-店長' },
            { positionName: POSITION_OTHER, dataClickLabel: 'CT_Jobinformation_職種-その他' }
        ]
    },

    parameterMapping: {
        area: {
            "仙台市": { city_id: 262 },
            "仙台市外": { city_id: 272 },
            "岩手県": { city_id: 229 },
            "秋田県": { city_id: 301 },
            "山形県": { city_id: 326 },
            "福島県": { city_id: 361 },
        },
        genre: {
            [GENRE_ITALIAN_CAFE]: { genre_id: 1 },
            [GENRE_ITALIAN]: { genre_id: 1 },
            [GENRE_CAFE]: { genre_id: 20 },
            [GENRE_PATISSERIE]: { genre_id: 21 },
            [GENRE_CHINESE]: { genre_id: 17 },
            [GENRE_IZAKAYA]: { genre_id: 11 },
            [GENRE_WESTERN]: { genre_id: 4 },
            [GENRE_SUSHI]: { genre_id: 7 },
            [GENRE_HOTEL]: { genre_id: 23 },
        },
        position: {
            [POSITION_KITCHEN_STAFF]: { position_id: 4 },
            [FILTER_POSITION_SERVICE_STAFF]: { position_id: 3 },
            [POSITION_RESTAURANT_SERVICE_STAFF]: { position_id: 3 },
            [FILTER_POSITION_HEAD_CHEF]: { position_id: 2 },
            [POSITION_HEAD_CHEF_CANDIDATE]: { position_id: 2 },
            [FILTER_POSITION_MANAGER]: { position_id: 1 },
            [POSITION_MANAGER_CANDIDATE]: { position_id: 1 },
            [POSITION_OTHER]: { position_id: 30 },
            [POSITION_SUPERVISOR]: { position_id: 19 },
            [POSITION_PATISSIER]: { position_id: 11 },
        },
    },

    jobInformationData: {
        dataClickLabels: {
            area: 'CT_Jobinformation_エリア',
            genre: 'CT_Jobinformation_料理ジャンル',
            position: 'CT_Jobinformation_職種',
        }
    },

    faqData: [
        {
            id: 1,
            question: '本当にお金はかかりませんか？',
            answer: 'はい。弊社のサービスにつきまして、お金は一切かかりません。ご利用して頂いた求職者様の中には「面接を受けたら、入社したらお金が発生する」と思っている方もいらっしゃいますが、そういったこともございませんのでご安心くださいませ。ただし、面談や面接にお越しいただく際の交通費は実費でのご負担になりますのでご了承下さいませ。',
            dataClickLabel: 'CT_Question_Accordion-1st'
        },
        {
            id: 2,
            question: '在職中で、まだ転職を検討中ですが利用しても大丈夫ですか？',
            answer: 'もちろん大丈夫です。在職中の方からも多くご相談いただいておりまして、面接日も弊社が求職者様のスケジュールにあわせて調整していきます。入社日につきましても、現職先の退社日にあわせて、弊社が代わって転職先の企業様と調整いたします。',
            dataClickLabel: 'CT_Question_Accordion-2nd'
        },
        {
            id: 3,
            question: '全然時間がなくて、面談はそちらへ行かないとダメですか？',
            answer: '基本的にはご来社いただいて、面談でキャリアアドバイザーと直接お話しした方がスムーズに進めますが、現在ではテレビ電話のアプリを利用したWEB面談も実施しております。新型コロナウイルス感染症の一件もございますので、感染を懸念される方や時間が全くない方に関しましてはご予約の際に伝えていただけますと幸いです。',
            dataClickLabel: 'CT_Question_Accordion-3rd'
        },
        {
            id: 4,
            question: '早めに仕事がしたいのですが、どれくらいで転職できますか？',
            answer: '企業様のスケジュールにもよりますが、大体1～2週間くらいをみていただければと思います。しかし、ケースによっては面談した日に面接、その場で内定をいただいて入社！という最速１日で転職できることもありますので、担当のキャリアアドバイザーにご相談ください。',
            dataClickLabel: 'CT_Question_Accordion-4th'
        },
        {
            id: 5,
            question: '内定をいただいたところに必ず入社しないといけないのでしょうか？',
            answer: '必ず入社する必要はございません。企業への辞退連絡に関しても、弊社の方で対応しますので、ご安心ください。また、複数の企業を受けて内定をいくつかいただいていて迷われている場合も、担当のキャリアアドバイザーにご相談ください。',
            dataClickLabel: 'CT_Question_Accordion-5th'
        },
    ],
    footerData: {
        companyInfo: '株式会社クオレガ\nフーズラボエージェント\n〒105-0004東京都港区新橋1丁目10-6\n新橋M-SQUARE11階',
        licenseInfo: '厚生労働大臣許可番号有料職業紹介事業許可番号\n13-ユ-308506\n',
        dataClickLabels: {
            pageTop: 'FT_FooterArea_PageTop',
            termsOfService: 'FT_FooterArea_利用規約',
            privacyPolicy: 'FT_FooterArea_プライバシーポリシー'
        }
    },
    officeData: [
        {
            id: 1,
            name: 'tokyo',
            image: '/renewal_lp/Office/office_tokyo.png',
            alt: '東京本社 東京都港区新橋1丁目10-6新橋M-SQUARE11F',
            title: '東京本社',
            address: '東京都港区新橋1丁目10-6\n新橋M-SQUARE11F',
        },
        {
            id: 2,
            name: 'kansai',
            image: '/renewal_lp/Office/office_kansai.png',
            alt: '関西支社 大阪府大阪市北区梅田2丁目4-9ブリーゼタワー17F',
            title: '関西支社',
            address: '大阪府大阪市北区梅田2丁目4-9\nブリーゼタワー17F',
        },
        {
            id: 3,
            name: 'nagoya',
            image: '/renewal_lp/Office/office_nagoya.png',
            alt: '名古屋支社 愛知県名古屋市中村区名駅3丁目28-12大名古屋ビルヂング11階',
            title: '名古屋支社',
            address: '愛知県名古屋市中村区名駅3丁目28-12\n大名古屋ビルヂング11階',
        },
        {
            id: 4,
            name: 'fukuoka',
            image: '/renewal_lp/Office/office_fukuoka.png',
            alt: '福岡支社 福岡県福岡市中央区天神1丁目13-17福岡天神1丁目ビル7階',
            title: '福岡支社',
            address: '福岡県福岡市中央区天神1丁目13-17\n福岡天神1丁目ビル7階',
        },
        {
            id: 5,
            name: 'sapporo',
            image: '/renewal_lp/Office/office_sapporo.png',
            alt: '札幌支社 北海道札幌市中央区南1条西5丁目20郵政福祉札幌第一ビル4階',
            title: '札幌支社',
            address: '北海道札幌市中央区南1条西5丁目20\n郵政福祉札幌第一ビル4階',
        },
    ],
    stepFormLabels: {
        step0: {
            dataViewLabel: 'EF_StepForm_Step0-転職意欲',
            dataClickLabels: {
                high: 'EF_StepForm_Step0-転職意欲-転職したい',
                moderate: 'EF_StepForm_Step0-転職意欲-情報収集',
                close: 'EF_StepForm_Step0-閉じる',
                blank: 'EF_StepForm_Step0-空白',
            }
        },
        step1: {
            dataViewLabel: 'EF_StepForm_Step1-現在の状況',
            dataClickLabels: {
                working: 'EF_StepForm_Step1-現在の状況-在籍中',
                unemployed: 'EF_StepForm_Step1-現在の状況-離職中',
            }
        },
        step2: {
            dataViewLabel: 'EF_StepForm_Step2-経験年数',
            dataClickLabels: {
                lessThan1: 'EF_StepForm_Step2-経験年数-1年未満',
                oneToFive: 'EF_StepForm_Step2-経験年数-1~5年',
                fiveToTen: 'EF_StepForm_Step2-経験年数-5~10年',
                moreThan10: 'EF_StepForm_Step2-経験年数-10年以上',
                back: 'EF_StepForm_Step2-経験年数-戻る'
            }
        },
        step3: {
            dataViewLabel: 'EF_StepForm_Step3-お住まい',
            dataClickLabels: {
                back: 'EF_StepForm_Step3-お住まい-戻る',
                next: 'EF_StepForm_Step3-お住まい-次へ'
            }
        },
        step4: {
            dataViewLabel: 'EF_StepForm_Step4-名前年齢',
            dataClickLabels: {
                back: 'EF_StepForm_Step4-名前年齢-戻る',
                next: 'EF_StepForm_Step4-名前年齢-次へ'
            }
        },
        step5: {
            dataViewLabel: 'EF_StepForm_Step5-連絡先',
            dataClickLabels: {
                back: 'EF_StepForm_Step5-連絡先-戻る',
                link: 'EF_StepForm_Step5-連絡先-Link-利用規約',
                cta: 'EF_StepForm_Step5-連絡先-CVボタン',
                lineCheckbox: 'EF_StepForm_Step5-連絡先-LINEチェック'
            }
        },
    },
}
